import React from "react";
import IconButton from "@material-ui/core/IconButton";
import StarIconSelected from "@material-ui/icons/Star";
import StarIcon from "@material-ui/icons/StarBorder";
import styled from "styled-components";

interface FavoritesButtonProps {
    onClick: () => void;
    selected: boolean;
}

const StyledStarIconSelected = styled(StarIconSelected)`
  fill: #D45D00 !important;
`;

const FavoritesButton = (props: FavoritesButtonProps) => {
    const {selected, onClick} = props;

    return (
            <IconButton
                edge={'end'}
                onClick={onClick}
            >
                {
                    selected ? <StyledStarIconSelected />
                        : <StarIcon/>
                }
            </IconButton>
    );
};

export default FavoritesButton;